import { Controller } from "@hotwired/stimulus"
import { average } from "../echart-helper";



export default class extends Controller {
  connect() {
    const chartElement = document.getElementById('predict-contract-chart-by-person');
    const personXAxis = JSON.parse(this.data.get("person_x_axis"));
    const personTraceProject = JSON.parse(this.data.get("person_trace_project"));
    const personTraceContract = JSON.parse(this.data.get("person_trace_contract"));
    const personToSignedContract = JSON.parse(this.data.get("person_to_signed_contract"));
    const isDarkTheme = document.body.dataset.coreuiTheme === "dark";
    const chartTitleColor = isDarkTheme ? '#f8f9fa' : '#212529';
    const chartTextColor = isDarkTheme ? '#d7dfeb' : '#495057';
    const chartAxisColor = isDarkTheme ? '#aebccc' : '#6c757d';
    const chartSplitLineColor = isDarkTheme ? 'rgba(215, 223, 235, 0.35)' : '#d9dfe7';
    const chartDataLabelStyle = isDarkTheme ? {
      color: chartTitleColor,
      textBorderColor: '#111827',
      textBorderWidth: 2
    } : {};
    const chartTooltipStyle = {
      backgroundColor: isDarkTheme ? '#202a3a' : '#ffffff',
      borderColor: chartAxisColor,
      textStyle: { color: chartTitleColor }
    };

    const people = personXAxis.map((name, index) => {
      const values = [personTraceProject[index], personTraceContract[index], personToSignedContract[index]].map(Number);
      return { name, values, total: values.reduce((sum, value) => sum + value, 0) };
    }).sort((a, b) => b.total - a.total);
    const avgPersonSum = people.length ? average(people.map(person => person.total)) : 0;
    const formatAmount = value => Number(value).toLocaleString('zh-CN', { maximumFractionDigits: 1 });
    chartElement.style.height = `${Math.max(360, people.length * 36 + 100)}px`;
    this.chart = echarts.init(chartElement);

    const option_by_person = {
      color: ['#a9d832', '#72789e', '#ff9855'],
      legend: {
        top: 0,
        bottom: null,
        selectedMode: false,
        data: ['跟踪项目', '跟踪合同', '待签合同'],
        textStyle: { color: chartTextColor }
      },
      tooltip: {
        trigger: 'axis',
        confine: true,
        ...chartTooltipStyle,
        axisPointer: { type: 'shadow' },
        valueFormatter: value => `${formatAmount(value)} 万元`
      },
      grid: { left: 110, right: 100, top: 55, bottom: 45 },
      toolbox: {
        iconStyle: { borderColor: chartTextColor },
        feature: { dataView: {}, saveAsImage: { pixelRatio: 2 } }
      },
      xAxis: {
        type: 'value',
        position: 'top',
        axisLabel: { color: chartTextColor, formatter: value => `${formatAmount(value)}万` },
        splitLine: { lineStyle: { color: chartSplitLineColor } }
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: people.map(person => person.name),
        axisLabel: { color: chartTextColor, interval: 0, width: 95, overflow: 'truncate' },
        axisLine: { show: false },
        axisTick: { show: false }
      },
      series: ['跟踪项目', '跟踪合同', '待签合同'].map((name, index) => ({
        name,
        type: 'bar',
        stack: 'total',
        barMaxWidth: 22,
        data: people.map(person => person.values[index]),
        emphasis: { focus: 'series' },
        label: {
          show: index === 2,
          position: 'right',
          formatter: params => formatAmount(people[params.dataIndex].total),
          ...chartDataLabelStyle
        },
        ...(index === 0 && people.length ? {
          markLine: {
            silent: true,
            symbol: 'none',
            label: { position: 'start', formatter: `平均 ${formatAmount(avgPersonSum)}万`, ...chartDataLabelStyle },
            lineStyle: { type: 'dashed', color: chartAxisColor },
            data: [{ xAxis: avgPersonSum }]
          }
        } : {})
      }))
    };

    const seriesNameMapping = option_by_person.legend.data;
    function drill_down_person_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const person_name = people[params.dataIndex].name;
          const month_name = $('#month_name').val();
          const sent_data = { person_name, month_name, series_name: seriesNameMapping[params.seriesIndex] };
          let drill_down_url = '/report/people_predict_contract/drill_down_person_detail';

          $.ajax(drill_down_url, {
            data: sent_data,
            dataType: 'script'
          });
        }
      }
    }

    this.chart.setOption(option_by_person, false);
    this.chart.on('click', drill_down_person_detail);

    this.resizeTimer = setTimeout(() => {
      this.chart.resize();
    }, 200);
  }

  layout() {
    this.chart.resize();
  }

  disconnect() {
    clearTimeout(this.resizeTimer);
    this.chart.dispose();
  }
}
